import ChatTextItem from './ChatTextItem';
export default ChatTextItem;
